// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Srrkm","cards":"styles_cards__QIKAX","card":"styles_card__aChFb"};